module.exports = __webpack_public_path__ + "static/img/huaweiMatePadM3.7766fe7a.png";